<script setup lang="ts">
import {useAuthentication} from "~/stores/authentication";
import {storeToRefs} from "pinia";
import {CrownIcon} from "vue-tabler-icons";
import {useCustomizerStore} from "~/stores/customizer";
import {useApplicationState} from "~/stores/application-state";

const {pictureUrl, name, email, root, loading: authLoading} = storeToRefs(useAuthentication())
const {isLoading: appLoading} = storeToRefs(useApplicationState())
const {darkMode, extraWide} = storeToRefs(useCustomizerStore());
const {setDarkMode, setExtraWide} = useCustomizerStore()

const changeTheme = () => {
  setDarkMode(!darkMode.value)
};

const changeExtraWide = () => {
  setExtraWide(!extraWide.value)
};

const loading = computed(() => authLoading.value || appLoading.value)
</script>

<template>
  <div>
    <v-menu>
      <template #activator="{ props }">
        <v-sheet icon v-bind="props" class="d-flex gap-3 align-center px-4 cursor-pointer">
          <v-skeleton-loader type="list-item-avatar-two-line" width="300" :loading="loading">
            <div class="d-flex gap-3 align-center">
              <v-badge :icon="CrownIcon" color="#FFBB48" v-if="root">
                <v-avatar :image="pictureUrl"></v-avatar>
              </v-badge>
              <v-avatar :image="pictureUrl" v-else></v-avatar>
              <div>
                <div>{{ name }}</div>
                <div>{{ email }}</div>
              </div>
            </div>
          </v-skeleton-loader>
          <div>
            <ChevronDownIcon class="mt-3"/>
          </div>
        </v-sheet>
      </template>
      <v-list>
        <v-list-item-title>
          <v-btn href="https://library.axoniq.io/axoniq-console-getting-started/main/index.html" variant="text"
                 color="primary" style="width: 100%" target="_blank">
            <BookIcon stroke-width="1.5" class="mr-1" size="22"/>
            Browse documentation
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <v-btn @click.prevent="changeTheme" variant="text" color="primary" style="width: 100%">
            <BulbFilledIcon stroke-width="1.5" class="mr-1" size="22" v-if="!darkMode"/>
            <BulbIcon stroke-width="1.5" class="mr-1" size="22" v-if="darkMode"/>
            Switch to {{ !darkMode ? 'dark' : 'light' }} theme
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <v-btn @click.prevent="changeExtraWide" variant="text" color="primary" style="width: 100%">
            <ArrowAutofitContentFilledIcon stroke-width="1.5" size="20" v-if="extraWide"/>
            <ArrowAutofitContentIcon stroke-width="1.5" size="20" v-else/>
            Switch to {{ !extraWide ? 'extra wide' : 'normal width' }} layout
          </v-btn>
        </v-list-item-title>
        <v-list-item-title v-if="root">
          <v-btn variant="text" to="/root" color="primary" style="width: 100%">
            <ExclamationCircleIcon stroke-width="1.5" class="mr-1" size="22"/>
            Super Administration
          </v-btn>
        </v-list-item-title>
        <v-list-item-title>
          <NavbarLogout/>
        </v-list-item-title>
      </v-list>
    </v-menu>
  </div>
</template>
